import { GetterTree } from "vuex";
import { RootState } from "@/store/types"
import { MenusState } from './types'
import { InfoItem } from "@/common/acl";

export const getters: GetterTree<MenusState, RootState> = { 

    getTest(state):string{
        return state.test
    },
    getCurrentSidebarElement:(state) : string => state.currentSidebarElement


 }